import { i18n } from 'core/localization';

let targetTypes: Record<string, string>;

export function getTargetTypes() {
	if (!targetTypes) {
		targetTypes = Object.freeze({
			ASSET: i18n('Asset'),
			ASSET_GROUP: i18n('Asset Group'),
		});
	}

	return targetTypes;
}
